<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>标签管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-row class="text item">
          <el-form-item prop="tagname"
                        label="类别名称:">
            <el-input v-model="form.tagname"
                      placeholder="请输入展示给用户的标签类别名称"></el-input>
          </el-form-item>
          <el-form-item prop="tagdesc"
                        label="类别描述:">
            <el-input v-model="form.tagdesc"
                      placeholder="请输入类别描述(仅主平台可见)"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary"
                     size="mini"
                     native-type="submit"
                     v-if="loading">保存
          </el-button>
          <router-link :to="{ path: '/teke_tag/table'}">
            <el-button type="primary"
                       size="mini">取消
            </el-button>
          </router-link>
        </el-row>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { searchRules } from '../tekeTag.rules.js'

export default {
  data () {
    return {
      loading: true,
      searchRules,
      selectLoading: false,
      form: {
        id: this.$route.params.tagid,
        tagname: null,
        tagdesc: null,
        price: null,
        level: 0,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getTag()
  },
  methods: {
    ...Vuex.mapActions(['editTekeTag', 'getTekeTag']),
    getTag () {
      return request.page('getTekeTag', this.form.id).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          return request.common('editTekeTag', this.form).then(({data}) => {
            this.$message({
              showClose: true,
              message: '创建成功',
              type: 'success',
            })
            this.loading = false
            window.location.href = '/teke_tag/table'
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/teke-tag/pages/TekeTagUpdate.vue